import React from 'react';

export type PixelGlyphType = 'arrow-up-right' | 'arrow-right' | 'chevron-right' | 'grid-dots' | 'pulse-dot' | 'corner';

interface PixelGlyphProps {
  name: PixelGlyphType;
  className?: string;
  size?: number;
  color?: string;
}

export const PixelGlyph: React.FC<PixelGlyphProps> = ({
  name,
  className = '',
  size = 18,
  color = 'currentColor',
}) => {
  switch (name) {
    case 'arrow-up-right':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`shrink-0 inline-block ${className}`}
        >
          {/* 8-bit stepped pixel diagonal arrow */}
          <rect x="6" y="2" width="8" height="2" fill={color} />
          <rect x="12" y="4" width="2" height="8" fill={color} />
          <rect x="10" y="4" width="2" height="2" fill={color} />
          <rect x="8" y="6" width="2" height="2" fill={color} />
          <rect x="6" y="8" width="2" height="2" fill={color} />
          <rect x="4" y="10" width="2" height="2" fill={color} />
          <rect x="2" y="12" width="2" height="2" fill={color} />
        </svg>
      );

    case 'arrow-right':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`shrink-0 inline-block ${className}`}
        >
          <rect x="2" y="7" width="10" height="2" fill={color} />
          <rect x="10" y="5" width="2" height="2" fill={color} />
          <rect x="12" y="7" width="2" height="2" fill={color} />
          <rect x="10" y="9" width="2" height="2" fill={color} />
        </svg>
      );

    case 'chevron-right':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`shrink-0 inline-block ${className}`}
        >
          <rect x="4" y="2" width="2" height="2" fill={color} />
          <rect x="6" y="4" width="2" height="2" fill={color} />
          <rect x="8" y="6" width="2" height="2" fill={color} />
          <rect x="10" y="8" width="2" height="2" fill={color} />
          <rect x="8" y="10" width="2" height="2" fill={color} />
          <rect x="6" y="12" width="2" height="2" fill={color} />
          <rect x="4" y="14" width="2" height="2" fill={color} />
        </svg>
      );

    case 'grid-dots':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`shrink-0 inline-block ${className}`}
        >
          <rect x="2" y="2" width="2" height="2" fill={color} />
          <rect x="7" y="2" width="2" height="2" fill={color} />
          <rect x="12" y="2" width="2" height="2" fill={color} />
          <rect x="2" y="7" width="2" height="2" fill={color} />
          <rect x="7" y="7" width="2" height="2" fill={color} />
          <rect x="12" y="7" width="2" height="2" fill={color} />
          <rect x="2" y="12" width="2" height="2" fill={color} />
          <rect x="7" y="12" width="2" height="2" fill={color} />
          <rect x="12" y="12" width="2" height="2" fill={color} />
        </svg>
      );

    case 'pulse-dot':
      return (
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-none bg-sunset-gold opacity-75"></span>
          <span className="relative inline-flex rounded-none h-2.5 w-2.5 bg-sunset-gold"></span>
        </span>
      );

    case 'corner':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`shrink-0 ${className}`}
        >
          <rect x="0" y="0" width="12" height="2" fill={color} />
          <rect x="0" y="2" width="2" height="10" fill={color} />
        </svg>
      );

    default:
      return null;
  }
};
